import React from "react";
import {
  TableRow,
  TableCell,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { ExpandMore, ExpandLess, Delete } from "@mui/icons-material";

const CategoryRow = ({
  category,
  editRowId,
  editData,
  handleChange,
  handleEdit,
  handleSave,
  handleCancel,
  handleDelete, 
  expanded,
  toggleExpand,
}) => {
  return (
    <>
      <TableRow>
        {/* Expand / Collapse icon */}
        <TableCell>
          <IconButton size="small" onClick={() => toggleExpand(category.id)}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </TableCell>

        {/* Category name */}
        <TableCell>
          {editRowId === category.id ? (
            <TextField
              value={editData[category.id]?.name || ""}
              onChange={(e) => handleChange(category.id, "name", e.target.value)}
              fullWidth
              size="small"
            />
          ) : (
            category.name
          )}
        </TableCell>

        {/* Category description */}
        <TableCell>
          {editRowId === category.id ? (
            <TextField
              value={editData[category.id]?.description || ""}
              onChange={(e) =>
                handleChange(category.id, "description", e.target.value)
              }
              fullWidth
              size="small"
            />
          ) : (
            category.description
          )}
        </TableCell>

        {/* Action buttons */}
        <TableCell>
          {editRowId === category.id ? (
            <>
              <Button
                size="small"
                variant="contained"
                color="success"
                onClick={() => handleSave(category.id)}
                sx={{ mr: 1 }}
              >
                Save
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>
              {/* 🗑 Delete button while editing */}
              <Button
                size="small"
                variant="outlined"
                color="error"
                startIcon={<Delete />}
                onClick={() => handleDelete(category.id)}
              >
                Delete
              </Button>
            </>
          ) : (
            <>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleEdit(category.id)}
                sx={{ mr: 1 }}
              >
                Edit
              </Button>
              {/* 🗑 Delete button when not editing */}
              <Button
                size="small"
                variant="outlined"
                color="error"
                startIcon={<Delete />}
                onClick={() => handleDelete(category.id)}
              >
                Delete
              </Button>
            </>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export default CategoryRow;
